








import Vue, { PropType } from 'vue';
import { DropdownItemTypes } from '../dropdowns.basics.types';

export default Vue.extend({
  name: 'DropdownItem',
  props: {
    selected: Boolean,
    type: {
      type: String as PropType<DropdownItemTypes>,
      default: () => 'default',
    },
  },
});
